// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CombinedLabel_wrapper__2KeP-"};